"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../constants/index.js");
var _index2 = require("../../../helpers/index.js");
var currencyCodes = _index.eventFieldValues.currencyCodes;
var stringField = _index2.formatters.stringField,
  numberField = _index2.formatters.numberField,
  listField = _index2.formatters.listField;
var getPurchaseTemplate = function getPurchaseTemplate(_ref) {
  var priceTotal = _ref.priceTotal,
    deviceConfiguration = _ref.deviceConfiguration,
    productStatus = _ref.productStatus,
    numberOfRgus = _ref.numberOfRgus,
    numberOfAccessories = _ref.numberOfAccessories,
    numberOfPhones = _ref.numberOfPhones,
    numberOfTablets = _ref.numberOfTablets,
    numberOfWatches = _ref.numberOfWatches,
    purchaseID = _ref.purchaseID,
    deviceTradeIn = _ref.deviceTradeIn,
    conversionDate = _ref.conversionDate,
    cartID = _ref.cartID,
    cartSource = _ref.cartSource,
    checkoutType = _ref.checkoutType,
    checkoutSteps = _ref.checkoutSteps,
    shipBOPIS = _ref.shipBOPIS,
    shipToHome = _ref.shipToHome,
    shippingMethod = _ref.shippingMethod,
    transactionType = _ref.transactionType,
    payments = _ref.payments;
  var priceTotalValue = numberField(priceTotal);
  var paymentsValue = payments === null || payments === void 0 ? void 0 : payments.map(function (_ref2) {
    var activationFee = _ref2.activationFee,
      transactionID = _ref2.transactionID,
      paymentAmount = _ref2.paymentAmount,
      paymentType = _ref2.paymentType;
    return {
      _telus: {
        activationFee: {
          amount: numberField(activationFee)
        },
        customTransactionID: transactionID
      },
      paymentAmount: numberField(paymentAmount),
      paymentType: stringField(paymentType),
      currencyCode: currencyCodes.CAD,
      transactionID: transactionID
    };
  });
  return {
    _telus: {
      priceTotal: {
        amount: priceTotalValue
      },
      deviceConfiguration: stringField(deviceConfiguration),
      productStatus: productStatus,
      numberOfRgus: numberField(numberOfRgus),
      numberOfAccessories: numberField(numberOfAccessories),
      numberOfPhones: numberField(numberOfPhones),
      numberOfTablets: numberField(numberOfTablets),
      numberOfWatches: numberField(numberOfWatches)
    },
    purchases: {
      value: 1
    },
    cart: {
      cartID: cartID,
      cartSource: stringField(cartSource)
    },
    checkouts: {
      _telus: {
        checkoutSteps: listField(checkoutSteps, {
          separator: '|'
        })
      }
    },
    order: {
      purchaseID: purchaseID,
      currencyCode: currencyCodes.CAD,
      priceTotal: priceTotalValue,
      _telus: {
        priceTotal: priceTotalValue,
        deviceTradeIn: {
          amount: numberField(deviceTradeIn),
          conversionDate: stringField(conversionDate)
        },
        checkoutType: stringField(checkoutType),
        customPurchaseID: purchaseID,
        shipBOPIS: typeof shipBOPIS === 'boolean' ? shipBOPIS.toString() : 'false',
        shipToHome: typeof shipToHome === 'boolean' ? shipToHome.toString() : 'true',
        shippingMethod: stringField(shippingMethod),
        transactionType: stringField(transactionType)
      },
      payments: paymentsValue
    }
  };
};
var _default = exports["default"] = getPurchaseTemplate;